import gql from 'graphql-tag';

export default gql`
  fragment preleadFaxNumberFragment on PreleadFaxNumber {
    name
    faxNumber
  }
`;
